import { Img, ImgProps } from 'remotion';

// Hooks
import { useImageErrorHandler } from '@/hooks';

type FallbackRemotionImgProps = Omit<ImgProps, 'src'> & {
  src?: string | null;
};

/**
 * FallbackRemotionImg - A wrapper around Remotion's Img component with built-in error handling.
 * Prevents video crashes when images fail to load by gracefully hiding failed images.
 *
 * @example
 * ```tsx
 * <FallbackRemotionImg
 *   src={imageUrl}
 *   className="size-full object-cover"
 *   alt="Description"
 * />
 * ```
 */
export const FallbackRemotionImg = ({
  src,
  ...props
}: FallbackRemotionImgProps) => {
  const { hasError, handleError } = useImageErrorHandler();

  if (hasError || !src) return null;

  return <Img src={src} {...props} onError={() => handleError(src)} />;
};
